export default __webpack_public_path__ + "static/media/222.cfad90f4.gif";